import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";
import { BreakPointDesktop, BreakPointMobile } from "../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    justifyContent: "flex-end",
    gap: theme.spacing.space48,
    boxSizing: "border-box",
    background: "#000",
    [BreakPointDesktop]: {
      borderRadius: theme.radius.large,
    },
    [BreakPointMobile]: {
      padding: 0,
      gap: 0,
    },
  },
  deviceImage: {
    width: "100%",
    objectFit: "cover",
  },
  container: {
    borderRadius: theme.radius.large,
    textAlign: "center",
    justifyItems: "center",
    width: "100%",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    [BreakPointDesktop]: {
      width: 600,
      position: "fixed",
      transform: "translate(-50%, -50%)",
      top: "50%",
      left: "50%",
      borderRadius: theme.radius.large,
      background: "#000",
      overflow: "hidden",
    },
    [BreakPointMobile]: {
      position: "absolute",
      boxSizing: "border-box",
      top: 0,
      overflow: "scroll",
      height: window.innerHeight,
    },
  },
  background: {
    width: "100%",
    height: "100%",
    position: "absolute",
    objectFit: "cover",
    top: 0,
    left: 0,
    zIndex: -1,
  },
  logo: {
    height: 78,
    paddingBottom: theme.spacing.space32,
    [BreakPointDesktop]: {
      display: "none",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",
    boxSizing: "border-box",
    gap: theme.spacing.space4,
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    margin: "auto",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    width: 400,
    alignItems: "center",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    padding: `32px 16px 48px 16px`,
    [BreakPointDesktop]: {
      width: "100%",
      padding: `32px 48px 48px`,
      gap: theme.spacing.space8,
      position: "relative",
      transform: "none",
      left: "unset",
      top: "unset",
    },
    [BreakPointMobile]: {
      width: "100%",
      top: "65%",
    },
  },
  description: {
    whiteSpace: "pre-line",
  },
  codeForm: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing.space8,
    color: theme.colors.TextDefault,
    fontSize: 18,
    fontWeight: 500,
    paddingTop: theme.spacing.space32,
    [BreakPointDesktop]: {
      paddingTop: theme.spacing.space40,
    },
  },
  codeInput: {
    flex: 1,
  },
  buttonsAction: {
    display: "grid",
    gap: theme.spacing.space24,
    paddingTop: theme.spacing.space20,
    width: "100%",
    [BreakPointMobile]: {
      gap: theme.spacing.space12,
    },
  },
  button: {
    [BreakPointMobile]: {
      minWidth: "unset",
    },
  },
  active: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
  secondDescription: {
    paddingTop: theme.spacing.space16,
    fontWeight: `${theme.fontWeight.bold} !important`,
  },
  error: {
    display: "flex",
    padding: `${theme.spacing.space4}px ${theme.spacing.space8}px`,
    gap: theme.spacing.space4,
    textAlign: "start",
    paddingBottom: 0,
  },
  errorIcon: {
    color: theme.colors.NotificationError,
    paddingTop: 2,
  },
  inputContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing.space24}px 0`,
    [BreakPointDesktop]: {
      flexDirection: "row",
      gap: theme.spacing.space24,
    },
  },
  warning: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.space8,
    gap: theme.spacing.space4,
    paddingLeft: theme.spacing.space8,
  },
  warningIcon: {
    color: theme.colors.NotificationError,
    flexShrink: 0,
  },
  avatarButton: {
    position: "relative",
    alignSelf: "center",
    width: 75,
    height: 75,
    padding: 3,
    boxSizing: "border-box",
    borderRadius: "50%",
    cursor: "pointer",
    [BreakPointDesktop]: {
      width: 100,
      height: 100,
      minWidth: 100,
    },
  },
  avatarButtonSelected: {
    boxShadow: `0 0 0 2px ${theme.colors.TextDefault}`,
  },
  avatar: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },
  avatarBadge: {
    position: "absolute",
    padding: theme.spacing.space6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
  },
  profileName: {
    paddingTop: theme.spacing.space12,
    paddingBottom: theme.spacing.space8,
    textAlign: "start",
  },
  inputName: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
}));
